export const INDEX = "/";
export const LOGIN = "/login";
export const POLICY = "/policy";
export const TERMS = "/terms";
export const PASSWORD_RECOVER = "/password/recover";
export const PASSWORD_RESET = "/password/reset/:otp";
export const SCALING = "/scaling";
export const STATISTICS = "/statistics";
export const GENERATOR = "/workout/generate";
export const CREATE_WORKOUT = "/workout/create";
export const PROFILE = "/profile";
export const SHOW_WORKOUT = "/workout/";
export const PERFORMANCE = "/performance";
export const USER_WORKOUTS = "/workouts/user";
export const PUBLIC_WORKOUTS = "/workouts/public";
export const DASHBOARD = "/dashboard";
export const INTRO = "/intro";
export const ERROR = "*";
export const ADMIN = "/admin";
export const VERIFY_EMAIL = "verify/email/:token";
export const DELETE_ACCOUNT = "account/delete/:token";
export const DELETE_INFO = "account/delete/info";
export const DONATE = "/donate";
export const CHALLENGES = "/challenges";
